<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VrHPAu/tc-custom/9781682303153.jpg?1704761644287" alt="This image is the cover for the book Any Other Name, The Split Worlds"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Any Other Name, The Split Worlds
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Second in the series that “weav[es] magic, mystery, and parallel worlds together with ease” (</b><b>Adam Christopher, author of the official <i>Stranger Things</i> tie-in novels).</b></p><p>Thought-provoking, wonderfully inventive, and filled with treachery and mystery, the soaring second book in the Split Worlds Series pulls Cathy, Will, Max, and Sam deeper into the twisted world of Fae-touched society. <br/><br/> Cathy has been reluctantly married into the Iris family and moves to Londinium, the magical Nether reflection of London, setting her on a collision course with the restrictive, high-pressure social circles that demand propriety and obedience, things the vocal and free-spirited Cathy cannot abide. Will, meanwhile, is trying to find a compromise for his new bride, but whispers in his ear are urging him towards dark deeds . . .  <br/><br/> Sam, determined to dive back into the world of Exilium to rescue innocents, crosses paths with Cathy and Max once again as Max and the gargoyle uncover more information about the mysterious Agency and the chain of events that wiped out the Bath Chapter. Sacrifices, terrible deals, and dreadful revelations mark this second installment of Emma Newman’s wondrous Split Worlds series.</p><p><b>Praise for the Split Worlds series</b></p><p>“JK Rowling meets Georgette Heyer.”—<i>The Guardian</i></p><p>“Emma Newman has built a modern fantasy world with such élan and authority her ideas of why and how the seemingly irrational world of Fairy works should be stolen by every other writer in the field.”—Bill Willingham, Eisner Award-winning author of <i>Fables</i></p> “Learning to be a young lady has never seemed so dangerous.”—Mary Robinette Kowal, Hugo and Nebula Award-winning author of the Lady Astronaut series
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emma Newman
      </h2>
      
      <p class="authorDescription body article">Emma Newman is a British author and podcaster, writing science fiction and fantasy. She was nominated for the British Fantasy Award as best newcomer in 2014. She has published nine novels and a collection of short fiction. Her hobbies include Live Action Role Playing and dressmaking.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1186d79c